import classNames from 'classnames';
import { FC } from 'react';

import { FilterType, SelectedFilterType } from '@/shared/config';
import { Icon } from '@/shared/ui';

import styles from './filterCategories.module.scss';

interface FiltersCategoriesProps {
  filters: FilterType[];
  className?: string;
  onClick: (index: number) => void;
  selectedFilters?: SelectedFilterType[];
  onRemove: (arg1: number, arg2: number) => void;
}

const FilterCategories: FC<FiltersCategoriesProps> = (props) => {
  const { filters, selectedFilters = [], className, onClick, onRemove } = props;

  function renderSelectedFiltersList(attribute: number) {
    const currentFilter = filters.find(
      (item) => item.attribute_id === attribute,
    );

    const selectedFilterForAttribute = selectedFilters?.find(
      (selectedFilter) => selectedFilter.attribute_id === attribute,
    );

    const selectedValueIds = selectedFilterForAttribute?.values || [];

    if (!selectedFilterForAttribute) {
      return null;
    }

    return (
      <div className={classNames(styles.list__row, styles.list__row_filters)}>
        {currentFilter?.values
          .filter((value) => selectedValueIds.includes(+value.value))
          .map((item) => {
            return (
              <button
                key={`selected-${attribute}-${item.value}`}
                className={styles.list__btn}
                onClick={(event) => {
                  event.stopPropagation();
                  onRemove(attribute, +item.value);
                }}
              >
                {item.label} <Icon name="crossBig" />
              </button>
            );
          })}
      </div>
    );
  }

  return (
    <ul className={classNames(styles.list, className)}>
      {filters?.map((filter, index) => {
        return (
          <li
            key={`${filter.attribute_name}-${index}`}
            className={styles.list__item}
            onClick={() => onClick(filter.attribute_id)}
          >
            <div className={styles.list__row}>
              <p className={styles.list__item_text}>{filter.attribute_name}</p>
              <Icon className={styles.list__item_icon} name="chevron" />
            </div>
            {renderSelectedFiltersList(filter.attribute_id)}
          </li>
        );
      })}
    </ul>
  );
};

export default FilterCategories;
